var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.675,
    height: 22.67,
    viewBox: "0 0 22.675 22.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-instagram",
    "data-name": "Icon awesome-instagram",
    d: "M11.335,7.76a5.812,5.812,0,1,0,5.812,5.812A5.8,5.8,0,0,0,11.335,7.76Zm0,9.591a3.779,3.779,0,1,1,3.779-3.779,3.786,3.786,0,0,1-3.779,3.779Zm7.406-9.829a1.356,1.356,0,1,1-1.356-1.356A1.353,1.353,0,0,1,18.741,7.523ZM22.59,8.9a6.709,6.709,0,0,0-1.831-4.75,6.753,6.753,0,0,0-4.75-1.831c-1.872-.106-7.482-.106-9.353,0a6.743,6.743,0,0,0-4.75,1.826A6.731,6.731,0,0,0,.074,8.894c-.106,1.872-.106,7.482,0,9.353A6.709,6.709,0,0,0,1.906,23a6.762,6.762,0,0,0,4.75,1.831c1.872.106,7.482.106,9.353,0A6.709,6.709,0,0,0,20.759,23a6.753,6.753,0,0,0,1.831-4.75c.106-1.872.106-7.477,0-9.348ZM20.172,20.255a3.826,3.826,0,0,1-2.155,2.155c-1.492.592-5.033.455-6.682.455S6.14,23,4.652,22.41A3.826,3.826,0,0,1,2.5,20.255c-.592-1.492-.455-5.033-.455-6.682s-.132-5.2.455-6.682A3.826,3.826,0,0,1,4.652,4.735c1.492-.592,5.033-.455,6.682-.455s5.2-.132,6.682.455A3.826,3.826,0,0,1,20.172,6.89c.592,1.492.455,5.033.455,6.682S20.764,18.768,20.172,20.255Z",
    transform: "translate(0.005 -2.238)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ec27c8edd7dbbb35d39fc563a6fedcdf.svg";
export { ForwardRef as ReactComponent };